import { IAction } from '@chainlit/react-client';

import { ActionButton } from './ActionButton';

interface Props {
  actions: IAction[];
}

export default function MessageActions({ actions }: Props) {
  return (
    <div className="flex flex-col gap-2">
      {actions.map((a) => (
        <ActionButton action={a} key={a.id} />
      ))}
    </div>
  );
}
